import lowerFirst from 'lodash/lowerFirst'

import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

const transactionOriginatorTypeValues = new Set<string>(Object.values(TransactionOriginatorType))

const isTransactionOriginatorType = (value: string): value is TransactionOriginatorType =>
  transactionOriginatorTypeValues.has(value)

/* We receive transaction type from BE in a regular string format (e.g., "Invoice") */
/* This function is to ensure that the string is converted to a valid TransactionOriginatorType or brought to undefined if it is weird, which should not happen */
/* Ultimately it is used for redirection to a specific transaction type page (like /bill or /invoice) and if this type is not recognized, the URL just won't be built */
export const toTransactionOriginatorType = (
  originatorType: string | undefined,
): TransactionOriginatorType | undefined => {
  if (!originatorType) {
    return undefined
  }

  const normalized = lowerFirst(originatorType)
  return isTransactionOriginatorType(normalized) ? normalized : undefined
}
